export const tr = {
    'agency:': 'Ajans temsilcisi:',
    'manager:': 'Yönetici:'
};
